//inventory_reducer.js - FIXED
const initial_state = {
  inventoryItems: [],
};
const inventoryReducer = (state = initial_state, action) => {
  switch (action.type) {
    case "GET_INVENTORY_ITEMS":
      console.log(action);
      return Object.assign({}, state, {
        inventoryItems: Array.isArray(action.inventoryItems) ? action.inventoryItems : [],
      });

    // ✅ FIXED: Complete case with proper property name
    case "EDIT_INVENTORY_ITEM_QUANTITY": {
      // ✅ Use action.inventoryItem (singular) not action.inventoryItems (plural)
      const updated_inventoryItem = action.inventoryItem;
      console.log("Update Item", updated_inventoryItem);

      // ✅ Add safety check for array
      if (!Array.isArray(state.inventoryItems)) {
        console.warn('⚠️ inventoryItems is not an array, initializing as empty array');
        return {
          ...state,
          inventoryItems: updated_inventoryItem ? [updated_inventoryItem] : []
        };
      }

      return {
        ...state,
        inventoryItems: state.inventoryItems.map((item) => {
          // ✅ Add safety check for item
          if (!item) return item;

          if (item.POID === updated_inventoryItem.POID || item.id === updated_inventoryItem.id) {
            return { ...item, ...updated_inventoryItem };
          }
          return item;
        }),
      };
    }

    // ✅ ADD: Handle POST_INVENTORY_ITEM from product creation
    case "POST_INVENTORY_ITEM": {
      const newInventoryItem = action.inventoryItem;
      console.log("Post Inventory Item", newInventoryItem);

      // Check if item already exists
      const existingIndex = state.inventoryItems.findIndex(
        item => item && (item.POID === newInventoryItem.POID || item.productId === newInventoryItem.productId)
      );

      if (existingIndex >= 0) {
        // Update existing item
        const updatedItems = [...state.inventoryItems];
        updatedItems[existingIndex] = { ...updatedItems[existingIndex], ...newInventoryItem };
        return {
          ...state,
          inventoryItems: updatedItems,
        };
      } else {
        // Add new item
        return {
          ...state,
          inventoryItems: [...state.inventoryItems, newInventoryItem],
        };
      }
    }
    case "EDIT_INVENTORY_ITEM_QUANTITY_PURCHASE": {
      const updatedInventoryItems = action.inventoryItems;
      const updatedInventoryItemqtyAccepted = action.qty;
      const singleInventoryDetail = action.singleItemInventory;
      console.log(
        "Updated Items Purchase",
        singleInventoryDetail ? singleInventoryDetail.quantity : "No single item",
        updatedInventoryItemqtyAccepted
      );

      if (!Array.isArray(state.inventoryItems)) {
        return state;
      }

      const newInventoryItems = state.inventoryItems.map((item) => {
        if (!item) return item;

        // Find matching item in the update payload
        const updatedItem = updatedInventoryItems && Array.isArray(updatedInventoryItems)
          ? updatedInventoryItems.find((updated) => updated.Product_Id === item.POID)
          : null;

        console.log("inside redux update product", updatedItem);
        return updatedItem
          ? {
            ...item,
            quantity:
              Number(item.quantity || 0) +
              Number(updatedInventoryItemqtyAccepted),
          }
          : item;
      });

      console.log("Previous State:", state.inventoryItems);
      console.log("Next State:", newInventoryItems);
      return {
        ...state,
        inventoryItems: newInventoryItems,
      };
    }
    case "EDIT_ACTIVE_PRODUCTS_QUANTITY_ON_ORDER":
    case "EDIT_INVENTORY_ITEM_QUANTITY_ON_ORDER": {
      console.log("🔄 EDIT_INVENTORY_ITEM_QUANTITY_ON_ORDER", action);
      const productIds = action.id;
      const quantities = action.quantity;
      const isAdd = action.add !== undefined;
      if (!Array.isArray(state.inventoryItems)) {
        return state;
      }
      const updatedItems = state.inventoryItems.map((item) => {
        if (!item) return item;
        const index = productIds.indexOf(item.POID);
        if (index !== -1) {
          const qtyChange = quantities[index];
          const currentQty = Number(item.quantity || 0);
          const newQty = isAdd
            ? currentQty + Number(qtyChange)
            : currentQty - Number(qtyChange);

          return {
            ...item,
            quantity: newQty,
          };
        }
        return item;
      });

      return {
        ...state,
        inventoryItems: updatedItems,
      };
    }
    case "EDIT_INVENTORY_ITEM": {
      const updated_inventoryItem = action.inventoryItem;
      if (!Array.isArray(state.inventoryItems)) return state;

      return {
        ...state,
        inventoryItems: state.inventoryItems.map((item) => {
          if (item && (item.POID === updated_inventoryItem.POID || item.id === updated_inventoryItem.id)) {
            return {
              ...item,
              ...updated_inventoryItem
            };
          }
          return item;
        }),
      };
    }

    // ✅ ADD: Cross-slice synchronization for product updates
    case "POST_PRODUCTS":
    case "POST_ACTIVE_PRODUCTS":
    case "POST_DRAFT_PRODUCTS":
    case "EDIT_ACTIVE_PRODUCTS":
    case "EDIT_ACTIVE_PRODUCTS_QUANTITY_WEB":
    case "EDIT_ACTIVE_PRODUCTS_QUANTITY": {
      const product = action.products || action.active_product || action.draft_product || action.updated_product || action.updated_product?.[0];
      const productData = Array.isArray(product) ? product[0] : product;

      if (!productData || !Array.isArray(state.inventoryItems)) return state;

      const productId = productData.POID || productData.id || productData.productId;
      const targetId = productData.childOf && productData.childOf !== "null" ? productData.childOf : productId;

      console.log("🔄 inventory_reducer - Syncing ID:", targetId, "from action:", action.type);

      return {
        ...state,
        inventoryItems: state.inventoryItems.map(item => {
          if (item && (item.POID === targetId || item.productId === targetId || item.id === targetId || (item.childOf && item.childOf === targetId))) {
            return {
              ...item,
              ...productData,
              quantity: productData.quantity !== undefined ? productData.quantity : item.quantity
            };
          }
          return item;
        })
      };
    }
    case "CLEAR_INVENTORY_DATA":
      return initial_state;
    default:
      return state;
  }
};

export default inventoryReducer;
